module.exports = __webpack_public_path__ + "img/bg01.335af240.gif";